import { FC } from 'react';

import { Amenities } from 'shared/components/Amenities';
import { AreaPartsContainer } from 'shared/components/AreaParts';
import { CardDescriptionContainer } from 'shared/components/CardDescription';
import { IAmenitiesSchema } from 'shared/repositories/commercial-search-offers/entities/amenities/AmenitiesSchema';
import { IAreaPartsSchema } from 'shared/repositories/commercial-search-offers/entities/area_parts/AreaPartsSchema';
import { stopPropagation } from 'shared/utils/event/stopPropagation';

import styles from './FooterFactory.css';

type FooterFactoryProps = {
  amenities: IAmenitiesSchema | undefined;
  areaParts: IAreaPartsSchema | undefined;
  isShortListing: boolean;
};

export const FooterFactory: FC<FooterFactoryProps> = props => {
  const { amenities, areaParts, isShortListing } = props;

  if (areaParts) {
    return <AreaPartsContainer areaParts={areaParts} />;
  }

  const isCardWithAmenities = !!amenities?.list.length;

  if (isCardWithAmenities) {
    return (
      <div className={styles['amenities-wrapper']}>
        {!isShortListing && <CardDescriptionContainer isCardWithAmenities={isCardWithAmenities} />}
        <Amenities
          amenities={amenities.list}
          isShortListing={isShortListing}
          link={amenities.link}
          total={amenities.total}
          onMoreLinkClick={stopPropagation}
        />
      </div>
    );
  }

  return <CardDescriptionContainer isCardWithAmenities={isCardWithAmenities} />;
};
